import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";

export const marker_options = [
    "None",
    "BCL2",
    "KI67",
    "GATA 3",
    "CHROMOGRANIN",
    "ACTIN",
    "MYO D1",
    "DESMIN",
    "CK",
    "P40",
    "P63",
    "S100",
    "C4D",
    "TLE1",
    "PAX8",
    "MELANOSOME",
    "GFAP",
    "CK19",
    "CD56",
    "BCL6",
    "CK7",
    "BETA CATENIN",
    "SALL4",
    "CD138",
    "CD117",
    "TDT",
    "CALRETININ",
    "CD5",
    "CD10",
    "CD99",
    "CD23",
    "CK20",
    "CDX2",
    "MUM1",
    "SYNAPTOPHYSIN",
    "AMYLOID",
    "PD1",
    "P53",
    "ALK1",
    "CD31",
    "BOB-1",
    "ER",
    "PR",
    "HER-2NEU",
    "CD3",
    "CD20",
    "CD15",
    "CD45",
    "CD4",
    "ALK(lung)",
    "PSA",
    "PDL1",
    "P16",
    "MLH1",
    "MSH2",
    "MSH6",
    "PMS2",
    "KAPPA",
    "LAMBDA",
    "CD68",
    "CK 5/6",
    "CD2",
    "CD79a",
    "PAX5",
    "CD19",
    "AMACR",
    "MYOGENIN",
    "CD30",
    "CD8",
    "WT1",
    "FLI1",
    "CYCLIN D1",
    "CD1a",
    "TTF-1",
    "HEPPAR1",
    "IGG4",
    "IGG",
    "DOG1",
    "C3D",
    "VIMENTIN",
    "EMA",
    "NSE",
    "NAPSIN A",
    "CD34",
    "E-CADHERIN",
    "EBV-LMP-1",
    "SATB2",
    "MELAN A",
    "STAT6",
    "SOX10",
    "GLYPICAN 3",
    "CEA",
    "CMV",
    "PODOPLANIN (D2-40)",
    "ANDROGEN RECEPTOR",
    "MDM2",
    "UROPLAKIN 3",
    "INHIBIN",
    "MYELOPEROXIDASE",
    "H-CALDESMON",
    "CALCITONIN",
    "CD7",
    "INI-1",
    "PLA2R",
    "NKX 3.1",
    "INSM1",
    "ARGINASE 1",
    "CMYC",
    "SOX11",
    "Oct-02",
    "CD57",
    "CA9",
    "NKX 2.2",
    "SDHB",
    "TFE 3",
    "THYROGLOBULIN"
]

const MarkerSelector = ({ onMarkerSelect, preSelected }) => {
  preSelected = marker_options.includes(preSelected) ? preSelected : null;
  const [selectedMarker, setSelectedMarker] = useState(preSelected || null);
  
  useEffect(() => {
        setSelectedMarker(selectedMarker);
    }, [preSelected]);

  return (
    <Autocomplete
      options={marker_options}
      value={selectedMarker}
      onChange={(event, newValue) => {
        setSelectedMarker(newValue);
        if (onMarkerSelect) onMarkerSelect(newValue);
      }}
      disableClearable
      renderInput={(params) => (
        <TextField 
        {...params}
        label="Marker" 
        variant="outlined" 
        size="small" 
        fullWidth 
        sx={{ 
            margin: '1px 0px', 
            // marginTop: '15px', 
            '& .MuiInputBase-root': { height: '25px', backgroundColor: "#fff" },
            '& .MuiOutlinedInput-input': { 
                padding: '1px 10px',
                height: '100%',
                lineHeight: '1.2',
                fontSize: '12px',
                fontWeight: '300'
            },
            '& .MuiInputLabel-root': { top: '-7px' },
            '& .MuiInputLabel-shrink': { top: '-3px' } 
        }} 
        />
      )}
    />
  );
};

export default MarkerSelector;
